import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { FaCheckCircle, FaUsers } from 'react-icons/fa';
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { FaPlay } from "react-icons/fa";
// import logo from './image/brand-logo.png';
import { FaMapMarkedAlt, FaPassport, FaTicketAlt, FaPhoneAlt, FaCommentDots, FaUserCheck, FaHandshake } from 'react-icons/fa'; // For icon imports
import WOW from 'wow.js';
import { Container, Row, Col, Button, Modal, Carousel } from "react-bootstrap";
import Footer from "./footer";
import LatestUpdates from "./latestupdates";
import "./footer.css";
import "./img.css";
import "./carousel.scss";
import "./clearfix.scss";
import "./animate-min.css";
import "./animate.css";


const Home = () => {
    // Initialize WOW.js for animations
    useEffect(() => {
        const wow = new WOW();
        wow.init();
    }, []);

    return (
        <>
            <div className="carousel-header">
                <div id="carouselId" className="carousel slide" data-bs-ride="carousel">
                    {/* Indicators */}
                    <ol className="carousel-indicators">
                        <li data-bs-target="#carouselId" data-bs-slide-to="0" className="active"></li>
                        <li data-bs-target="#carouselId" data-bs-slide-to="1"></li>
                    </ol>

                    {/* Carousel Items */}
                    <div className="carousel-inner" role="listbox">
                        <div className="carousel-item active">
                            <img src="/img/carousel-11.png" className="img-fluid" alt="Carousel 1" />
                            <div className="carousel-caption">
                                <div className="text-center p-4" style={{ maxWidth: "900px" }}>
                                    <h4 className="display-1 text-capitalize text-white mb-3 mb-md-4 wow fadeInUp" data-wow-delay="0.3s">
                                        Turn Your Study Dreams into Reality
                                    </h4>
                                    <p className="text-white mb-4 mb-md-5 fs-5 wow fadeInUp" data-wow-delay="0.3s">
                                    With 19+ years of experience, Bajwa Immigration Consultants specialises in visa applications and guidance in studying abroad. Let us help you make your dreams come true   </p>                                 <a
                                        className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5 wow fadeInUp"
                                        data-wow-delay="0.7s"
                                        href="https://au.bajwaimmigration.com/book-appointment"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Book Appointment
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="carousel-item">
                            <img src="/img/carousel-11.png" className="img-fluid" alt="Carousel 2" />
                            <div className="carousel-caption">
                                <div className="text-center p-4" style={{ maxWidth: "900px" }}>
                                    <h4 className="display-1 text-capitalize text-white mb-3 mb-md-4 wow fadeInUp" data-wow-delay="0.3s">
                                        Skilled & Permanent Migration Made Easy
                                    </h4>
                                    <p className="text-white mb-4 mb-md-5 fs-5 wow fadeInUp" data-wow-delay="0.3s">
                                    19+ years of expertise. Bajwa Immigration Consultants - your trusted partner for success while studying abroad.   
                                    </p>
                                    <a
                                        className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5 wow fadeInUp"
                                        data-wow-delay="0.7s"
                                        href="https://au.bajwaimmigration.com/book-appointment"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Book Appointment
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Carousel Controls */}
                    {/* <button className="carousel-control-prev" type="button" data-bs-target="#carouselId" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon bg-secondary wow fadeInLeft" data-wow-delay="0.2s" aria-hidden="true"></span>
                        <span className="visually-hidden-focusable">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselId" data-bs-slide="next">
                        <span className="carousel-control-next-icon bg-secondary wow fadeInRight" data-wow-delay="0.2s" aria-hidden="true"></span>
                        <span className="visually-hidden-focusable">Next</span>
                    </button> */}
                </div>
            </div>

            {/* about */}

            <div className="container-fluid py-5">
                <div className="container py-5">
                    <div className="row g-5">
                        {/* Left Column */}
                        <div className="col-xl-5 wow fadeInLeft" data-wow-delay="0.1s">
                            <div className="bg-light rounded">
                                <img src="img/about-2.png" className="img-fluid w-100" style={{ marginBottom: '-7px' }} alt="About" />
                                <img
                                    src="img/about-3.jpg"
                                    className="img-fluid w-100 border-bottom border-5 border-primary"
                                    style={{ borderTopRightRadius: '300px', borderTopLeftRadius: '300px' }}
                                    alt="About"
                                />
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="col-xl-7 wow fadeInRight" data-wow-delay="0.3s">
                            <h5 className="sub-title pe-3">About the company</h5>
                            <h1 className="display-5 mb-4">We’re A Trusted Immigration Consultants Agency.</h1>
                            <p className="mb-4">
                                With years of experience, we specialize in providing reliable immigration solutions
                                tailored to your needs. Our expert team is committed to guiding you through every
                                step of the process, ensuring a smooth and successful transition to your new journey.
                            </p>
                            <div className="row gy-4 align-items-center">
                                <div className="col-12 col-sm-6 d-flex align-items-center">
                                    <FaMapMarkedAlt className="fa-3x text-secondary" />
                                    <h5 className="ms-4">Best Immigration Resources</h5>
                                </div>
                                <div className="col-12 col-sm-6 d-flex align-items-center">
                                    <FaPassport className="fa-3x text-secondary" />
                                    <h5 className="ms-4">Return Visas Available</h5>
                                </div>
                                <div className="col-4 col-md-3">
                                    <div className="bg-light text-center rounded p-3">
                                        <div className="mb-2">
                                            <FaTicketAlt className="fa-4x text-primary" />
                                        </div>
                                        <h1 className="display-5 fw-bold mb-2">19+</h1>
                                        <p className="text-muted mb-0">Years of Experience</p>
                                    </div>
                                </div>
                                <div className="col-8 col-md-9">
                                    <div className="mb-5">
                                        <p className="text-primary h6 mb-3"><FaCheckCircle className="text-secondary me-2" />
                                            Offer 100% Genuine Assistance
                                        </p>
                                        <p className="text-primary h6 mb-3"><FaCheckCircle className="text-secondary me-2" />
                                            It’s Faster & Reliable Execution
                                        </p>
                                        <p className="text-primary h6 mb-3"><FaCheckCircle className="text-secondary me-2" />
                                            Accurate & Expert Advice
                                        </p>
                                    </div>
                                    <div className="d-flex flex-wrap">
                                        <div id="phone-tada" className="d-flex align-items-center justify-content-center me-4">
                                            <a href="#" className="position-relative wow tada" data-wow-delay=".9s">
                                                <FaPhoneAlt className="text-primary fa-3x" />
                                                <div className="position-absolute" style={{ top: 0, left: '25px' }}>
                                                    <span><FaCommentDots className="text-secondary" /></span>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="d-flex flex-column justify-content-center">
                                            <span className="text-primary">Have any questions?</span>
                                            <span className="text-secondary fw-bold fs-5" style={{ letterSpacing: '2px' }}>
                                            <a href="/contact" className="text-muted me-0 attention-shake">
                                            <i className="text-secondary me-2"></i>Let’s Connect
                                         </a>

                                            </span>   
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* counter facts */}

           <div className="container-fluid counter-facts py-5">
            <div className="container py-5">
                <div className="row g-4 justify-content-center">
                    {/* First Counter */}
                    <div className="col-12 col-sm-6 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="counter text-center">
                            <div className="counter-icon">
                                <FaPassport style={{ fontSize: "4.5rem" }} />
                            </div>
                            <div className="counter-content">
                                <h3>ACCREDITATIONS AND ACCOLADES</h3>
                                <div className="d-flex align-items-center justify-content-center">
                                    <span style={{ fontSize: "30px", fontWeight: "bold", color: "#22327f" }}>
                                        <CountUp start={0} end={18} duration={3} />
                                    </span>
                                    <h4 className="text-secondary mb-0" style={{ fontWeight: 600, fontSize: '25px' }}>+</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Second Counter */}
                    <div className="col-12 col-sm-6 col-md-4 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="counter text-center">
                            <div className="counter-icon">
                                <FaUsers style={{ fontSize: "4.5rem" }} />
                            </div>
                            <div className="counter-content">
                                <h3>Team Members</h3>
                                <div className="d-flex align-items-center justify-content-center">
                                    <span style={{ fontSize: "30px", fontWeight: "bold", color: "#22327f" }}>
                                        <CountUp start={0} end={70} duration={3} />
                                    </span>
                                    <h4 className="text-secondary mb-0" style={{ fontWeight: 600, fontSize: '25px' }}>+</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Third Counter */}
                    <div className="col-12 col-sm-6 col-md-4 wow fadeInUp" data-wow-delay="0.5s">
                        <div className="counter text-center">
                            <div className="counter-icon">
                                <FaUserCheck style={{ fontSize: "4.5rem" }} />
                            </div>
                            <div className="counter-content">
                                <h3>Visas Processed</h3>
                                <div className="d-flex align-items-center justify-content-center">
                                    <span style={{ fontSize: "30px", fontWeight: "bold", color: "#22327f" }}>
                                        <CountUp start={0} end={70000} duration={3} separator="," />
                                    </span>
                                    <h4 className="text-secondary mb-0" style={{ fontWeight: 600, fontSize: '25px' }}>+</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            {/* service */}

            <div className="container-fluid service overflow-hidden pt-5">
                <div className="container py-5">
                    <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h5 className="sub-title text-primary px-3">Enabling Your Immigration Successfully</h5>
                        </div>
                        <h1 className="display-5 mb-4">OUR SERVICES</h1>
                        <p className="mb-0">
                            We provide expert immigration assistance to make your journey smooth and hassle-free.
                            From visa applications to legal consultations, our dedicated team ensures a seamless
                            process tailored to your needs.
                        </p>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="img/service-1.png" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a href="" className="h4 text-white mb-0">Course / Admissions</a>
                                            </div>
                                            <a className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4" href="#">Explore More</a>
                                        </div>
                                        <div className="service-content pb-4">
                                            <a href="#">
                                                <h4 className="text-white mb-4 py-3">Course / Admissions</h4>
                                            </a>
                                            <div className="px-4">
                                                <p className="mb-4">
                                                    We help students to choose their dream course at most affordable cost and top institutions.
                                                    Contact Us today for expert consultation about your future.
                                                </p>
                                                <Link to="/coursechange" className="btn btn-primary border-secondary rounded-pill py-3 px-5" >Explore More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="img/course.png" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a href="#" className="h4 text-white mb-0">Student Visa</a>
                                            </div>
                                            <a className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4" href="#">Explore More</a>
                                        </div>
                                        <div className="service-content pb-4">
                                            <a href="#">
                                                <h4 className="text-white mb-4 py-3">Student Visa</h4>
                                            </a>
                                            <div className="px-4">
                                                <p className="mb-4">
                                                    Do you want to study Abroad ? We can help you to study in your desired country.
                                                    Call Or Send an Enquiry Below for FREE Consultations.
                                                </p>
                                                <Link to="/studyvisa" className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5">Explore More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="img/service-3.jpg" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a href="#" className="h4 text-white mb-0">PR Pathways</a>
                                            </div>
                                            <a className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4" href="#">Explore More</a>
                                        </div>
                                        <div className="service-content pb-4">
                                            <a href="#">
                                                <h4 className="text-white mb-4 py-3">PR Pathways</h4>
                                            </a>
                                            <div className="px-4">
                                                <p className="mb-4">
                                                    Australia is one of the admirable country. Plan your PR pathway with us.
                                                    Send Your enquire today and get best tailored advice.
                                                </p>
                                                <Link to="/workingvisa" className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5" >Explore More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="img/partner.png" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a href="#" className="h4 text-white mb-0">Partner Visa</a>
                                            </div>
                                            <a className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4" href="#">Explore More</a>
                                        </div>
                                        <div className="service-content pb-4">
                                            <a href="#">
                                                <h4 className="text-white mb-4 py-3">Partner Visa</h4>
                                            </a>
                                            <div className="px-4">
                                                <p className="mb-4">
                                                    We are expert of Partner or Spouse visa which allows you to stay with your partner when they study or work abroad.
                                                    Reach us today and get a FREE consultation to live with your partner in Australia.
                                                </p>
                                                <Link to="/partner" className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5" >Explore More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="img/service-1.jpg" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a href="#" className="h4 text-white mb-0">Business Visa</a>
                                            </div>
                                            <a className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4" href="#">Explore More</a>
                                        </div>
                                        <div className="service-content pb-4">
                                            <a href="#">
                                                <h4 className="text-white mb-4 py-3">Business Visa</h4>
                                            </a>
                                            <div className="px-4">
                                                <p className="mb-4">
                                                    Are you interested to start a business in Australia? There are various streams of investors and entrepreneurs to grow in Australia.
                                                    Our Experts can help you to grow with your business. Book an appointment Today.
                                                </p>
                                                <Link to="/workingvisa" className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5" >Explore More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="img/Refusal.png" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a href="#" className="h4 text-white mb-0">Refusal/Cancel</a>
                                            </div>
                                            <a className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4" href="#">Explore More</a>
                                        </div>
                                        <div className="service-content pb-4">
                                            <a href="#">
                                                <h4 className="text-white mb-4 py-3">Refusal/Cancellation</h4>
                                            </a>
                                            <div className="px-4">
                                                <p className="mb-4">
                                                    Is your Visa refused or cancelled? Australian Laws allow you to appeal in ART , which can help you to get a right visa.
                                                    Send your Enquiry today , Our team will reach you back to help you regarding this.
                                                </p>
                                                <Link to="/AATappeal" className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5" >Explore More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <VideoSection />

            {/*Appealss*/}

            <TestimonialsCarousel />
            {/* offices */}

            <div className="container-fluid contact overflow-hidden pb-5">
                <div className="container py-5">
                    <div className="office pt-5">
                        <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="sub-style">
                                <h5 className="sub-title text-primary px-3">COUNTRIES WE OFFER</h5>
                            </div>
                            <h1 className="display-5 mb-4">Immigration & visa services following Countries</h1>
                            <p className="mb-0">
                                We provide expert immigration and visa services for various countries, ensuring a seamless
                                transition for individuals and families. Whether you're looking to study, work, or settle abroad,
                                our team is here to guide you through the process. Our services cover visa applications, legal
                                documentation, and expert consultations to help you achieve your immigration goals with ease.
                            </p>
                        </div><div className="row g-4 justify-content-center">
   {[
                                             {
                                                 title: "Melbourne (CBD)",
                                                 phone1: "0390 770 507",
                                                 phone2: "0406 401 000",
                                                 email: "enquiries@bajwaimmigration.com",
                                                 address: "Century Building, Level 5/125 Swanston Street, Melbourne VIC 3000",
                                                
                                             },
                                             {
                                                 title: "Thomastown (Northern Suburbs)",
                                                 phone1: "0410 516 709",
                                                //  phone2: "0410 516 709",
                                                 email: " thomastown@bajwaimmigration.com",
                                                 address: " 177 High St. Thomastown VIC 3074",
                                                
                                             },
                                             {
                                                 title: "Blackburn (Eastern Suburbs)",
                                                 phone1: "0451 355 710",
                                                //  phone2: "0451 355 710",
                                                 email: "blackburn@bajwaimmigration.com",
                                                 address: "128 Whitehorse Rd, (Opp. Sikh Temple) Blackburn VIC 3130",
                                                
                                             },
                                             {
                                                 title: "Dandenong (Eastern Suburbs)",
                                                 phone1: "0451 355 710",
                                                //  phone2: "0451 355 710",
                                                 email: "amar@bajwaimmigration.com",
                                                 address: "Unit 7/147-151 Foster Street, Dandenong, VIC, 3175",
                                             },
  ].map((office, index) => (
    <div key={index} className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
      <div className="office-item p-4 h-100 d-flex flex-column border rounded shadow-sm">
        <div className="office-img mb-4">
          {/* <img src={office.img} className="img-fluid w-100 rounded" alt={office.title} /> */}
        </div>
        <div className="office-content d-flex flex-column flex-grow-1">
          <h4 className="mb-2">{office.title}</h4>
          <a href={`tel:${office.phone1}`} className="text-secondary fs-5 mb-2">
            {office.phone1} <br /> {office.phone2}
          </a>
          <a href={`mailto:${office.email}`} className="text-muted fs-5 mb-2 text-break">
            {office.email}
          </a>
          <p className="mb-0 mt-auto">{office.address}</p>
        </div>
      </div>
    </div>
  ))}
</div>

                        </div>
                    </div>
                </div>
            
            {/* footer */}
            < LatestUpdates />
           
            <Footer />
        </>
    );
};

export default Home;





const VideoSection = () => {
    return (
        <Container className="my-5">
            <Row className="align-items-center">
                {/* Left Section - Quote */}
                <Col md={5} className="text-center text-md-start">

                    <h3 className="fs-4 fw-bold">
                        "Choosing a Right migration agent is as important as choosing a good life partner."
                    </h3>
                    <div className="d-flex align-items-center justify-content-center justify-content-md-start">
                        <img
                            src="./img/jujhar.png"
                            alt="Mr. Jujhar Singh Bajwa"
                            className="rounded-circle me-2"
                            style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                            }}
                        />
                        <div>
                            <h6 className="fw-bold">Mr. Jujhar Singh Bajwa</h6>
                            <p className="text-muted small">Director (Bajwa Immigration Consultants)</p>
                        </div>
                    </div>
                    <Button variant="warning" className="fw-bold mt-3"><a href="https://www.youtube.com/c/BAJWAIMMIGRATIONCONSULTANTS" >VIEW MORE VIDEOS</a></Button>
                </Col>

                {/* Right Section - Embedded YouTube Video */}
                <Col md={7} className="text-center">
                    <div className="ratio ratio-16x9">
                        <iframe
                            width="100%"
                            height="400"
                            src="https://www.youtube.com/embed/uOGAB9oYets"
                            title="YouTube video"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </Col>
            </Row>

            {/* Feedback Button (Fixed Position) */}
            <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 start-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>

        </Container>
    );
};

const TestimonialsCarousel = () => {
    const testimonials = [
        {
            quote: "The team was extremely helpful and guided me through every step of the process. Highly recommended!",
            name: "jasmit bamrah",
            image: "./img/test1.png"
        },
        {
            quote: "Thanks to their expertise, my immigration process was smooth and stress-free!",
            name: "Avii Sharma",

            image: "./img/test2.png"
        },
        {
            quote: "Professional, efficient, and reliable. I couldn't have asked for a better experience!",
            name: "Saad ISRAR",

            image: "./img/test3.png"
        }
    ];

    return (
        <Container className="my-5">
            <h2 className="text-center text-primary mb-4">What Our Clients Say</h2>
            <Carousel>
                {testimonials.map((testimonial, index) => (
                    <Carousel.Item key={index}> 
                        <div className="d-flex flex-column align-items-center text-center p-4">
                            <img
                                src={testimonial.image}
                                alt={testimonial.name}
                                className="rounded-circle mb-3"
                                style={{ width: "100px", height: "100px", objectFit: "cover" }}
                            />
                            <p className="fs-5 fst-italic">❝    {testimonial.quote} ❞</p>
                            <h5 className="fw-bold mt-3">{testimonial.name}</h5>
                            <p className="text-muted">{testimonial.role}</p>
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>
        </Container>
    );
};




